import BaseClass from "../BaseClass";
import Helper from "../Helper";
import SliderGallery from "../media/SliderGallery";

const defaultOptions = {};

export default class Map extends BaseClass {

    /**
     * Constructor
     * @param {} options
     */
    constructor(options)
    {
        super(options, defaultOptions);
        window.markers = [];
        window.hideHotelMarkersBreakpoint = 10;

        this.init();
    }

    /**
     * Init function
     */
    init()
    {
        $(document).ready(() => {
            this.initMapDependencies();
        })
    }

    /**
     * Function that initializes map
     */
    initMap()
    {
        if (window.json_center_map === "" || window.json_center_map === null || window.json_center_map === undefined) {
            var center = new google.maps.LatLng(44.79085025468512, 11.404102);
        } else {
            var center = new google.maps.LatLng(window.json_center_map['lat'], window.json_center_map['lng']);
        }

        window.map = new google.maps.Map(document.getElementById('map'), Map.getMapOptions(center));

        let customZoomControlDiv = document.createElement('div');
        this.customZoomControl(customZoomControlDiv);

        customZoomControlDiv.index = 1;
        customZoomControlDiv.className = 'map__zoom-in-out--wrapper';
        window.map.controls[google.maps.ControlPosition.RIGHT_TOP].push(customZoomControlDiv);

        if (window.boundries !== undefined && window.boundries !== null && Object.values(window.boundries).indexOf(null) === -1) {
            this.fitBoundaries();
        }

        if (window.json_data === undefined) {
            return;
        }

        /**
         * HTML Marker
         *
         * @param {Number} latitutde
         * @param {Number} longitude
         * @param {Boolean} isLocation
         * @param {String} imageInputName
         * @param {Number} isBestseller
         * @param {String} price
         * @param {String} url
         * @param {Number} id
         * @param {String} html
         */
        window.htmlMarker = function HTMLMarker(
            latitutde,
            longitude,
            isLocation,
            imageInputName,
            isBestseller,
            price,
            url,
            id,
            html
        ) {
            this.lat = latitutde;
            this.long = longitude;
            this.image = imageInputName == undefined ? undefined : $("input[name="+imageInputName+"]").val();
            this.pos = new google.maps.LatLng(latitutde,longitude);
            this.isLocation = isLocation;
            this.star = $("input[name=star_map]").val();
            this.isBestseller = isBestseller;
            this.price = price;
            this.url = url;
            this.id = id;
            this.content = {
                text: html
            };
        }

        window.htmlMarker.prototype = new google.maps.OverlayView();
        window.htmlMarker.prototype.onRemove = function(){}

        //init your html element here
        window.htmlMarker.prototype.onAdd = function() {
            let hotelClass = '';
            if (window.map.getZoom() <= window.hideHotelMarkersBreakpoint) {
                hotelClass = 'hidden-mvio';
            }

            this.div = document.createElement('DIV');
            if (this.isLocation) {
                this.div.className = "map__marker map__marker-location";
            } else {
                if (this.image !== undefined) {
                    this.div.className = "map__marker map__marker-hotel " + hotelClass;
                } else {
                    this.div.className = "map__marker map__marker-hotel map__marker-hotel--text " + hotelClass;
                }
            }
            this.div.style.position='absolute';

            if (this.image !== undefined) {
                this.div.innerHTML = "<span>"+this.image+"</span>";
            } else {
                if (this.isBestseller) {
                    this.div.innerHTML = this.star + "<span class='map__marker-hotel--text_price'>"+this.price+" €</span>";
                } else {
                    this.div.innerHTML = "<span class='map__marker-hotel--text_price'>"+this.price+" €</span>";
                }
            }

            if (Helper.isLaptopOrHigher()) {
                $(this.div).on('click', (e) => {
                    window.clickMarker($(e), this.url);
                })
            }

            let eventName = Helper.isTabletOrLower() ? 'click' : 'mouseover';

            $(this.div).on(eventName, (e) => {
                window.hoverMarker(e, this.lat, this.long, this.id, this.content, this.isLocation ? 'location' : 'hotel');
            })

            var panes = this.getPanes();
            panes.overlayImage.appendChild(this.div);
        }

        window.htmlMarker.prototype.draw = function(){
            var overlayProjection = this.getProjection();
            var position = overlayProjection.fromLatLngToDivPixel(this.pos);

            this.div.style.left = position.x - $(this.div).actual('outerWidth') / 2 + 'px';
            this.div.style.top = position.y + 'px';
        }

        this.loopData(13);
    };

    /**
     * Function that updates map data
     */
    updateMap()
    {
        window.markers.forEach((e, i) => {
            $(window.markers[i].div).remove();
        })

        window.markers = [];

        this.loopData(13);
    }

    /**
     * Function that loops map data
     * @param zoom
     */
    loopData(zoom = null)
    {
        if (zoom !== null) {
            if (window.boundries !== undefined && window.boundries !== null && Object.values(window.boundries).indexOf(null) === -1) {
                this.fitBoundaries();
            } else {
                window.map.setZoom(zoom);
            }
        }

        if (window.json_center_map !== "" && window.json_center_map !== null && window.json_center_map !== undefined) {
            let center = new google.maps.LatLng(window.json_center_map['lat'], window.json_center_map['lng']);
            window.map.setCenter(center)
        }

        window.openedInfoWindow;

        for (let i = 0; i < window.json_data.count; i++) {
            if (window.json_data.photos[i] != null) {
                if (window.json_data.photos[i].photo_title === "Location") {
                    // Location
                    window.markers[i] = new window.htmlMarker(
                        parseFloat(window.json_data.photos[i].latitude),
                        parseFloat(window.json_data.photos[i].longitude),
                        true,
                        "home_map",
                        undefined,
                        undefined,
                        window.json_data.photos[i].owner_url,
                        window.json_data.photos[i].photo_id,
                        window.json_data.photos[i].html
                    );
                } else {
                    // Hotel
                    if (window.json_data.photos[i].empty) {
                        // without price
                        window.markers[i] = new window.htmlMarker(
                            parseFloat(window.json_data.photos[i].latitude),
                            parseFloat(window.json_data.photos[i].longitude),
                            false,
                            "bed_map",
                            undefined,
                            undefined,
                            window.json_data.photos[i].owner_url,
                            window.json_data.photos[i].photo_id,
                            window.json_data.photos[i].html
                        );
                    } else {
                        // with price
                        window.markers[i] = new window.htmlMarker(
                            parseFloat(window.json_data.photos[i].latitude),
                            parseFloat(window.json_data.photos[i].longitude),
                            false,
                            undefined,
                            window.json_data.photos[i].best_seller,
                            String(window.json_data.photos[i].price.toFixed(2)).replace(".", ","),
                            window.json_data.photos[i].owner_url,
                            window.json_data.photos[i].photo_id,
                            window.json_data.photos[i].html
                        );
                    }
                }

                window.markers[i].setMap(window.map);

                if (window.json_data.isCountry) {
                    $(window.map.getDiv()).addClass('country-map')
                }
            }
        }

        $('body').on('click', (event) => {
            if (!$(event.target).closest('.map__marker.opened').length && !$(event.target).closest('.map-pop-up').length) {
                if (window.openedInfoWindow !== undefined) {
                    window.openedInfoWindow.close();
                    window.openedInfoWindow = undefined;

                    if ($(window).width() <= window.mapBreakpoint) {
                        let openedMarker = $('.map__marker.opened');

                        if ($(openedMarker).length > 0) {
                            $(openedMarker).removeClass('opened');
                        }
                    }
                }
            }
        })

        google.maps.event.addListener(map, 'zoom_changed', function() {
            let zoomLevel = map.getZoom();

            if (zoomLevel <= window.hideHotelMarkersBreakpoint) {
                for (var i = 0; i < window.markers.length; i++) {
                    if (!window.markers[i].isLocation) {
                        if (!$(window.markers[i].div).hasClass('hidden-mvio')) {
                            $(window.markers[i].div).addClass('hidden-mvio');
                        }
                    }
                }
            } else {
                for (var i = 0; i < window.markers.length; i++) {
                    if (!window.markers[i].isLocation) {
                        $(window.markers[i].div).removeClass('hidden-mvio');
                    }
                }
            }
        });
    }

    /**
     * Function that binds info window dependencies
     *
     * @param {String} name
     */
    addMapBind(name)
    {
        google.maps.event.addListener(window.openedInfoWindow, 'domready',function () {
            if (Helper.isLaptopOrHigher()) {
                if (window.galleries[name] !== undefined) {
                    if (window.galleries[name].slider !== undefined) {
                        window.galleries[name].slider.destroy(true);
                    }
                    delete window.galleries[name];
                }

                let gallery = new SliderGallery(name, true);
                window.galleries[name] = gallery;
                gallery.initGallery();
            } else {
                Helper.handleMapPopupImage();
            }
        });
    }

    /**
     * Function that inits zoom on mouse over
     *
     * @param {Number} id hotel id
     * @param {Boolean} isLocation true if it is location event
     */
    toggleZoom(id, isLocation)
    {
        for (var i = 0; i < window.markers.length; i++) {
            if (isLocation == window.markers[i].isLocation && window.markers[i].id === id) {
                if (window.openedInfoWindow !== undefined) {
                    window.openedInfoWindow.close();
                    window.openedInfoWindow = undefined;
                }

                if ($(window.markers[i].div).hasClass('map__marker')) {
                    if (!window.markers[i].isLocation) {
                        $(window.markers[i].div).removeClass('hidden-mvio');
                    }

                    if (!$(window.markers[i].div).hasClass('hover')) {
                        $(window.markers[i].div).addClass('hover');
                    }
                } else {
                    if (!window.markers[i].isLocation) {
                        $(window.markers[i].div).parents('.map__marker').removeClass('hidden-mvio');
                    }

                    if (!$(window.markers[i].div).parents('.map__marker').hasClass('hover')) {
                        $(window.markers[i].div).parents('.map__marker').addClass('hover');
                    }
                }
                break;
            }
        }
    }

    /**
     * Function that stops zoom on mouseout
     *
     * @param {Number} id hotel id
     * @param {Boolean} isLocation true if it is location
     */
    stopZoom(id, isLocation)
    {
        for (var i = 0; i < window.markers.length; i++) {
            if (isLocation == window.markers[i].isLocation && window.markers[i].id === id) {
                if (window.openedInfoWindow !== undefined) {
                    window.openedInfoWindow.close();
                    window.openedInfoWindow = undefined;
                }

                if ($(window.markers[i].div).hasClass('map__marker')) {
                    if (!$(window.markers[i].div).hasClass('hidden-mvio')
                        && window.map.getZoom() <= window.hideHotelMarkersBreakpoint
                        && !window.markers[i].isLocation) {
                        $(window.markers[i].div).addClass('hidden-mvio');
                    }

                    if ($(window.markers[i].div).hasClass('hover')) {
                        $(window.markers[i].div).removeClass('hover');
                    }
                } else {
                    if (!$(window.markers[i].div).parents('.map__marker').hasClass('hidden-mvio')
                        && window.map.getZoom() <= window.hideHotelMarkersBreakpoint
                        && !window.markers[i].isLocation) {
                        $(window.markers[i].div).parents('.map__marker').addClass('hidden-mvio');
                    }

                    if ($(window.markers[i].div).parents('.map__marker').hasClass('hover')) {
                        $(window.markers[i].div).parents('.map__marker').removeClass('hover');
                    }
                }
                break;
            }
        }
    }

    /**
     * Function that inits dependencies of other things towards map
     */
    initMapDependencies()
    {
        if ($('[data-toggle-map-zoom]').length > 0) {
            $('[data-toggle-map-zoom]').each((i, e) => {

                $(e).on('mouseover', () => {
                    window.toggleZoom($(e).data('id'), $(e).data('toggleMapZoom') === 'location');
                });

                $(e).on('mouseout', () => {
                    window.stopZoom($(e).data('id'), $(e).data('toggleMapZoom') === 'location');
                })
            })
        }
    }

    /**
     * Function that creates custom +/- control buttons
     *
     * @param {Element} controlDiv wrapper element
     */
    customZoomControl(controlDiv)
    {
        // create + div
        let controlUI = document.createElement('div');
        controlUI.className = 'map__zoom-in-out__in';
        controlDiv.appendChild(controlUI);

        let controlText = document.createElement('div');
        controlText.className = 'map__zoom-in-out__in--text';
        controlText.innerHTML = $('input[name="plus_icon"]').val();
        controlUI.appendChild(controlText);

        // Setup the click event listeners
        google.maps.event.addDomListener(controlUI, 'click', function () {
            window.map.setZoom(window.map.getZoom() + 1);
        });

        // create - div
        controlUI = document.createElement('div');
        controlUI.className = 'map__zoom-in-out__out';
        controlDiv.appendChild(controlUI);

        controlText = document.createElement('div');
        controlText.className = 'map__zoom-in-out__out--text';
        controlText.innerHTML = $('input[name="minus_icon"]').val();
        controlUI.appendChild(controlText);

        // Setup the click event listeners
        google.maps.event.addDomListener(controlUI, 'click', function () {
            window.map.setZoom(window.map.getZoom() - 1);
        });
    }

    /**
     * Function that fits map boundries to show whole country
     */
    fitBoundaries()
    {
        let bounds = new google.maps.LatLngBounds(
            new google.maps.LatLng(window.boundries['south'], window.boundries['west']),
            new google.maps.LatLng(window.boundries['north'], window.boundries['east'])
        );

        window.map.fitBounds(bounds);
        window.map.panToBounds(bounds);
    }

    /**
     * Function that handles click on element
     *
     * @param {Element} element
     * @param {String} url
     */
    clickMarker(element, url) {
        window.open(url, '_blank').focus();

        if ($($(element)[0].target).hasClass('map__marker')) {
            if (!$($(element)[0].target).hasClass('clicked'))
                $($(element)[0].target).addClass('clicked');
        } else {
            if (!$($(element)[0].target).parents('.map__marker').hasClass('clicked'))
                $($(element)[0].target).parents('.map__marker').addClass('clicked');
        }
    }

    /**
     * Function that handles mouseover on element
     *
     * @param {Element} element
     * @param {Number} lat
     * @param {Number} long
     * @param {Number} id
     * @param {Object} content
     * @param {String} sliderType
     */
    hoverMarker(element, lat, long, id, content, sliderType) {
        if (window.openedInfoWindow === undefined
            || window.openedInfoWindow.id !== id
            || (window.openedInfoWindow.id === id && window.openedInfoWindow.type !== sliderType)) {

            if (window.openedInfoWindow !== undefined) {
                window.openedInfoWindow.close();

                if ($(window).width() <= window.mapBreakpoint) {
                    let openedMarker = $('.map__marker.opened');

                    if ($(openedMarker).length > 0) {
                        $(openedMarker).removeClass('opened');
                    }
                }
            }

            const latLng = { lat: lat, lng: long };

            const infoWindow = new google.maps.InfoWindow({
                content: content.text,
                position: latLng
            });

            infoWindow.open(window.map);
            window.openedInfoWindow = infoWindow;
            window.openedInfoWindow.id = id;
            window.openedInfoWindow.type = sliderType;
            window.addMapBind(sliderType+"-map-slider-"+id);

            if ($(window).width() <= window.mapBreakpoint) {
                if ($($(element)[0].target).hasClass('map__marker')) {
                    if (!$($(element)[0].target).hasClass('opened'))
                        $($(element)[0].target).addClass('opened');
                } else {
                    if (!$($(element)[0].target).parents('.map__marker').hasClass('opened'))
                        $($(element)[0].target).parents('.map__marker').addClass('opened');
                }
            }
        }
    }

    /**
     * Function thar returns JSON options for map
     *
     * @param {LatLng} center
     * @returns JSON
     */
    static getMapOptions(center) {
        return {
            zoom: 7,
            minZoom: 5,
            center: center,
            gestureHandling: "greedy",
            scaleControl: false,
            streetViewControl: false,
            fullscreenControl: false,
            mapTypeControl: false,
            mapTypeControlOptions: {
                mapTypeIds: [google.maps.MapTypeId.ROADMAP]
            },
            zoomControl: false,
            styles: [
                {
                    "featureType": "landscape.man_made",
                    "elementType": "geometry.fill",
                    "stylers": [ { "color": "#fee9e1" } ]
                },
                {
                     "featureType": "landscape.natural",
                     "elementType": "geometry.fill",
                     "stylers": [ { "lightness": 100 } ]
                },
                {
                    "featureType": "landscape.natural.landcover",
                    "elementType": "geometry.fill",
                    "stylers": [ { "lightness": 100 } ]
                },
                {
                    "featureType": "landscape.natural.terrain",
                    "elementType": "geometry.fill",
                    "stylers": [ { "lightness": -15 } ]
                },
                {
                    "featureType": "poi.attraction",
                    "stylers": [ { "visibility": "off" } ]
                },
                {
                    "featureType": "poi.business",
                    "stylers": [ { "visibility": "off" } ]
                },
                {
                    "featureType": "poi.government",
                    "stylers": [ { "visibility": "off" } ]
                },
                {
                    "featureType": "poi.medical",
                    "stylers": [ { "visibility": "off" } ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "geometry.fill",
                    "stylers": [ { "color": "#e0ffcc" } ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "labels.icon",
                    "stylers": [ { "visibility": "off" } ]
                },
                {
                    "featureType": "poi.place_of_worship",
                    "stylers": [ { "visibility": "off" } ]
                },
                {
                    "featureType": "poi.school",
                    "stylers": [ { "visibility": "off" } ]
                },
                {
                    "featureType": "poi.school",
                    "elementType": "labels.text",
                    "stylers": [ { "visibility": "off" } ]
                },
                {
                    "featureType": "poi.sports_complex",
                    "elementType": "geometry.fill",
                    "stylers": [ { "color": "#e7fed7" } ]
                },
                {
                    "featureType": "poi.sports_complex",
                    "elementType": "labels",
                    "stylers": [ { "visibility": "off" } ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "geometry.stroke",
                    "stylers": [ { "color": "#a1a1a1" } ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.icon",
                    "stylers": [ { "visibility": "off" } ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.fill",
                    "stylers": [ { "color": "#f0f0f0" } ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.stroke",
                    "stylers": [ { "color": "#bcbcbc" } ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "labels",
                    "stylers": [ { "visibility": "off" } ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "labels.icon",
                    "stylers": [ { "saturation": 40 } ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "geometry.stroke",
                    "stylers": [ { "color": "#cfcfcf" } ]
                },
                {
                    "featureType": "transit.line",
                    "elementType": "geometry.fill",
                    "stylers": [ { "color": "#dbdbdb" } ]
                },
                {
                    "featureType": "transit.station.airport",
                    "elementType": "geometry",
                    "stylers": [ { "lightness": 15 } ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry.fill",
                    "stylers": [ { "color": "#8cd7ff" },{ "lightness": 15 } ]
                }
            ]
        };
    }

    /**
     * Function that zooms to location
     *
     * @param {Element} element
     */
    zoomLocation(element) {
        let center = new google.maps.LatLng($(element).data('lat'),  $(element).data('long'));

        window.map.setCenter(center)
        window.map.setZoom(13);
    }
}